var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',{staticClass:"hidden-print"},[_vm._v("选择日期，计算天数")]),_c('Main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }